import { FileText, Search, Users } from 'lucide-react';
import React from 'react';

interface EmptyStateMessageProps {
  type?: 'search' | 'clients' | 'default';
  message?: string;
  icon?: React.ReactNode;
}

const iconMap = {
  search: Search,
  clients: Users,
  default: FileText,
};

const messageMap = {
  search: 'No results found',
  clients: 'No clients found',
  default: 'No items found',
};

const EmptyStateMessage: React.FC<EmptyStateMessageProps> = ({ type = 'default', message, icon }) => {
  const Icon = iconMap[type];
  const resolvedIcon = icon || <Icon className="w-10 h-10 text-slate-400 dark:text-slate-500" strokeWidth={1.5} />;

  return (
    <section className="py-10 px-4 text-center" role="status">
      <span className="flex items-center justify-center mx-auto mb-4">{resolvedIcon}</span>
      <span className="block text-lg font-semibold text-slate-900 dark:text-slate-100">
        {message || messageMap[type]}
      </span>
    </section>
  );
};

export default EmptyStateMessage;
